import styled from '@emotion/styled';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from '@mui/material';
import {
  BASE_FIELD_BACKGROUND_COLOR,
  BASIC_BORDER_COLOR,
  BASIC_BORDER_RADIUS,
  HIGH_EMPHASIS,
  TABLE_ODD_ROW_BACKGROUND_COLOR,
} from '../../themes/tokens';

interface IStyledTableCell {
  styledBgColor?: boolean;
}

export const TableHeadCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'styledBgColor',
})<IStyledTableCell>`
  background-color: ${({ styledBgColor }) => styledBgColor && TABLE_ODD_ROW_BACKGROUND_COLOR};
  font-weight: 700;
`;

export const TitleWrapper = styled(Box)`
  margin-top: 48px;
  margin-bottom: 16px;
`;

export const StyledTableContainer = styled(TableContainer)`
  background-color: transparent;
  border-radius: ${BASIC_BORDER_RADIUS};
  border: 1px solid ${BASIC_BORDER_COLOR};
`;

export const StyledTable = styled(Table)`
  background-color: transparent;
  backdrop-filter: blur(7px);
`;

export const StyledTableBody = styled(TableBody)`
  background-color: transparent;
`;

export const StyledTableFooter = styled(TableFooter)`
  background-color: transparent;
`;

export const StyledTableFooterHead = styled(TableRow)`
  background-color: transparent !important;
  &:last-child td,
  &:last-child th {
    border: 0;
  }

  td {
    padding: 0;
  }
`;

export const StyledTableFooterTitle = styled.p`
  color: ${HIGH_EMPHASIS};
  font-style: italic;
  font-weight: bold;
  font-size: 16px;
  margin-left: 15px;
`;

export const StyledTableHead = styled(TableHead)`
  background-color: ${BASE_FIELD_BACKGROUND_COLOR};
`;

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'backgroundColor',
})<{
  backgroundColor?: string;
}>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? `${backgroundColor} !important` : BASE_FIELD_BACKGROUND_COLOR};

  &:last-child td,
  &:last-child th {
    border: 0;
  }
`;

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'styledBgColor',
})<IStyledTableCell>`
  background-color: ${({ styledBgColor }) => styledBgColor && TABLE_ODD_ROW_BACKGROUND_COLOR};
`;

export const StyledGroupTableRow = styled(TableRow)`
  background-color: ${TABLE_ODD_ROW_BACKGROUND_COLOR};
  .MuiTableCell-root {
    font-weight: bold;
    font-style: italic;
  }
`;

export const StyledTableSubtitle = styled.p`
  font-weight: bold;
  font-style: italic;
  font-size: 16px;
  margin-left: 15px;
`;

export const StyledTableGap = styled(TableRow)`
  background-color: transparent !important;
  border: 0;
  &:last-child td,
  &:last-child th {
    border: 0;
  }
`;

export const StyledAddButton = styled(Button)`
  margin: 10px;
`;
